import script from "./HeaderComp.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComp.vue?vue&type=script&setup=true&lang=js"

import "./HeaderComp.vue?vue&type=style&index=0&id=6ec0a501&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec0a501"]])

export default __exports__